import React from 'react';
import AsyncComponent from '../components/AsyncComponent';
import './styles.scss';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  NavbarToggler,
} from 'reactstrap';
import i18n from '../i18n';

import HeaderLogo from '../images/carecity_horizontal_logo.png';

class Header extends AsyncComponent {
  constructor(props) {
    super(props);

    this.state = {
      cityName: 'Carecity',
      collapsed: false,
      language: i18n.getLanguageEnabled(),
    };

    this._toggleNavbar = this._toggleNavbar.bind(this);
    this._changeLanguage = this._changeLanguage.bind(this);
  }

  async componentDidMount() {
    await this.componentDidUpdate();
  }

  async componentDidUpdate() {
  }

  async _changeLanguage() {
    const newLanguage = i18n.getLanguageEnabled() === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLanguage);
    window.location.reload();
  }

  async _toggleNavbar() {
    await this.setStateAsync({
      collapsed: !this.state.collapsed
    });
  }

  _renderLanguageSelector() {
    return (
      <NavItem className='languageSelector' onClick={this._changeLanguage}>
        {this.state.language === 'fr' ? 'EN' : 'FR'}
      </NavItem>
    );
  }

  render() {
    return (
      <Navbar light expand="md">
        <NavbarBrand tag={Link} to={'/'}>
          <img
            className='logo_nav'
            alt='Carecity'
            src={HeaderLogo} />
        </NavbarBrand>
        <NavbarToggler onClick={this._toggleNavbar} />
        <Collapse isOpen={this.state.collapsed} navbar className='menu'>
          <Nav className="ms-auto" navbar>
            {process.env.REACT_APP_ALERT_FEED_FEATURE === 'true' && 
              <NavItem className="subscribeNav">
                <NavLink tag={Link} to='/AlertFeed'>{i18n.t('alertFeed')}</NavLink>
              </NavItem>
            }
            <NavItem className="subscribeNav">
              <NavLink tag={Link} to='/'>{i18n.t('subscribe')}</NavLink>
            </NavItem>
            <NavItem className="subscribeNav">
              <NavLink tag={Link} to='/Unsubscription'>{i18n.t('unsubscribe')}</NavLink>
            </NavItem>
            {this._renderLanguageSelector()}
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default Header;
